export default __webpack_public_path__ + "static/media/seguros1.28f66a25.png";